module.exports = __webpack_public_path__ + "static/background-1-77aef033c5faffbc00c6e82d18536bfe.svg";